import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Dropdown, TextInput, Image } from "hesus-ui-kit";
import PropTypes from "prop-types";
import orangeIcon from "@icons/ic-orange-arrow.svg";
import blueIcon from "@icons/ic-blue-arrow.svg";

import {
  renderPriceWithCurrencyWithoutUnit,
  renderPriceWithCurrency,
  addSpace,
  filterUnit,
} from "@utils/utils";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  noLabelStyles,
  dropdownStyles,
  dropdownStylesError,
} from "@utils/extra-style";
import {
  GridRow,
  HorizontalRow,
  GridSubLabel,
  GridItem,
  GridSubItem,
  GridSubItemAlign,
} from "../SiteFollowUp/SiteFollowUp.styled";
import "../../SiteView.scss";

const QuoteItems = (props) => {
  const {
    t,
    itemList,
    quoteCurrency,
    onChange,
    serviceIndex,
    exchangeRates,
    serviceCurrency,
  } = props;
  const getConvertedPrice = (currencyId, price) => {
    const rateInfo = exchangeRates?.find(
      (rate) => rate.currencyFrom === currencyId
    );
    return rateInfo ? rateInfo?.exchangeRate * price : price;
  };

  return (
    <>
      {itemList?.length > 0 &&
        itemList.map((item, itemIndex) => {
          return (
            <React.Fragment key={"site-follow-up-item" + itemIndex + 1}>
              {itemIndex !== 0 && <HorizontalRow />}

              <GridRow
                column="40% 20% 25% 15%"
                marginBottom="0px"
                gridGap="0rem"
                marginTop="0px"
                borderBottom={
                  itemList.length === parseInt(itemIndex, 10) + 1
                    ? "2px solid rgba(10, 73, 134, 0.3)"
                    : "0px solid rgba(10, 73, 134, 0.3)"
                }
              >
                <GridItem
                  borderLeft="2px solid rgba(10, 73, 134, 0.3)"
                  borderRight="2px solid rgba(10, 73, 134, 0.3)"
                >
                  <GridRow column="70% 30%" marginBottom="0px" marginTop="0px">
                    <div>
                      <GridSubLabel
                        color="#0A4986;
"
                      >
                        {String(item?.label.value) || ""}
                      </GridSubLabel>
                      <GridSubItem
                        color="#474747"
                        fontSize="14px"
                        fontStyle="italic"
                      >
                        {item.hesusService.value.needProduct &&
                          item.product.value.name}

                        {item.hesusService.value.needProduct &&
                          item.hesusService.value.needTransport &&
                          " - "}
                        {item.hesusService.value.needTransport &&
                          item.transport.value.name}
                        {!item.hesusService.value.needProduct &&
                          !item.hesusService.value.needTransport &&
                          " - "}
                      </GridSubItem>
                    </div>
                    <GridSubItemAlign
                      color="#474747"
                      fontSize="16px"
                      fontWeight="700"
                      textAlign="center"
                      fontStyle="normal"
                    >
                      {renderPriceWithCurrency(
                        item?.sellingPrice.value
                          ? addSpace(
                              getConvertedPrice(
                                serviceCurrency?.id,
                                item?.sellingPrice.value
                              )
                            )
                          : "",
                        t(item?.totalRealisedUnit.value),
                        quoteCurrency?.symbol,
                        quoteCurrency?.position
                      )}
                    </GridSubItemAlign>
                  </GridRow>
                </GridItem>
                <GridItem
                  style={{ display: "inline-grid", alignItems: "center" }}
                >
                  <GridSubItem
                    color="#0a4986"
                    fontSize="16px"
                    fontWeight="700"
                    textAlign="center"
                    fontStyle="normal"
                  >
                    {!item.hesusService.value.needClientOrder && (
                      <GridRow column="1fr">-</GridRow>
                    )}
                    {item.hesusService.value.needClientOrder && (
                      <GridRow column="1fr 1fr">
                        <TextInput
                          type="text"
                          name={item.quantity.name}
                          id={item.quantity.name}
                          isFloat
                          placeholder={t("QUANTITY")}
                          value={String(item.quantity.value)}
                          required={false}
                          errorStyles={{ "font-style": "italic" }}
                          onChange={(e) => {
                            onChange(e, serviceIndex, itemIndex, "quantity");
                          }}
                          labelStyles={
                            item.quantity.error !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          inputStyles={
                            item.quantity.error !== ""
                              ? inputStylesError
                              : inputStyles
                          }
                          error={item.quantity.error}
                        />
                        <Dropdown
                          name={item.unit.name}
                          id={item.unit.name}
                          value={String(item.unit.value)}
                          defaultOption={t("UNIT")}
                          options={filterUnit(item.quoteUnit, t)}
                          required={false}
                          onChange={(e) => {
                            onChange(e, serviceIndex, itemIndex, "unit");
                          }}
                          labelStyles={noLabelStyles}
                          inputStyles={
                            item.unit.error !== ""
                              ? dropdownStylesError
                              : dropdownStyles
                          }
                          error={item.unit.error}
                        />
                      </GridRow>
                    )}
                  </GridSubItem>
                </GridItem>
                <GridItem style={{ display: "grid" }}>
                  <GridSubItemAlign
                    color="#0a4986"
                    fontSize="16px"
                    fontWeight="400"
                    fontStyle="normal"
                    textAlign={item.quantity.value !== "" ? "right" : "center"}
                  >
                    <GridRow
                      column={item.quantity.value !== "" ? "auto auto" : "1fr"}
                      gridGap=".5rem"
                    >
                      {item.totalRealised.value ||
                      item.totalRealised.value === 0
                        ? item.totalRealised.value
                        : ""}{" "}
                      {t(item.totalRealisedUnit.value)}
                      {item.quantity.value !== "" && (
                        <>
                          {item.totalRealisedQuantity.value === "?" && (
                            <GridSubItemAlign
                              color="#f08046"
                              fontSize="16px"
                              fontWeight="400"
                              textAlign="left"
                              fontStyle="normal"
                              display="inline"
                            >
                              <Image
                                src={orangeIcon}
                                alt="totalRealisedQuantity"
                                className="site-view-enquiry__quote-icon"
                              />
                              {item.totalRealisedQuantity.value +
                                " " +
                                t(item.totalRealisedUnit.value)}
                            </GridSubItemAlign>
                          )}
                          {item.totalRealisedQuantity.value !== "?" && (
                            <GridSubItem
                              color="#3ebbb9"
                              fontSize="16px"
                              fontWeight="400"
                              textAlign="left"
                              fontStyle="normal"
                            >
                              <Image
                                src={blueIcon}
                                alt="totalRealisedQuantity"
                                className="site-view-enquiry__quote-icon"
                              />
                              {item.totalRealisedQuantity.value +
                                " " +
                                t(item.totalRealisedUnit.value)}
                            </GridSubItem>
                          )}
                        </>
                      )}
                    </GridRow>
                  </GridSubItemAlign>
                </GridItem>
                <GridItem style={{ display: "grid" }}>
                  <GridSubItemAlign
                    color={
                      item.totalRealisedQuantity.value === "?"
                        ? "#f08046"
                        : "#0a4986"
                    }
                    fontSize="16px"
                    fontWeight="700"
                    textAlign="center"
                    fontStyle="normal"
                  >
                    {renderPriceWithCurrencyWithoutUnit(
                      (item?.turnOver?.value || item?.turnOver?.value === 0) &&
                        item?.turnOver?.value !== "-"
                        ? addSpace(item?.turnOver?.value)
                        : "-",
                      quoteCurrency?.symbol,
                      quoteCurrency?.position
                    )}
                  </GridSubItemAlign>
                </GridItem>
              </GridRow>
            </React.Fragment>
          );
        })}
    </>
  );
};

QuoteItems.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
QuoteItems.defaultProps = {
  id: null,
};

export default withTranslation()(QuoteItems);
